import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaInputDialog } from '../alerta-input';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import * as moment from 'moment';

@Component({
  selector: 'app-shop-home',
  templateUrl: './shop-home.component.html',
  styleUrls: ['./shop-home.component.css']
})
export class ShopHomeComponent implements OnInit, OnDestroy {
  hideCL: boolean = false;
  listaProdutos: any[] = [];
  listaProdutosTermo: any[] = [];
  cidadeAtual: any = '';
  siglaUF: any = '';
  mUF: any = '';
  mCidade: any = '';
  qtyCart: any = 0;
  arrCategorias: any[] = [];
  arrSubCat: any[] = [];
  arrSubF: any[] = [];
  urlECfoto: any = '';
  arrBanners: any[] = [];
  urlBanner: any = '';
  bannerAtual: any = '';
  bannerIndex: any = 0;
  bannerBG: any = '';
  controlsEnabled: boolean = false;
  controlsReady: boolean = false;
  novaFoto: boolean = true;
  bannerClick: boolean = false;
  interval;
  exibirLF: boolean = false;
  contagemLF: any = 0;
  avoidP: boolean = true;
  hideCrown: boolean = false;
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }

  ngOnInit() {
    this.tmaService.eventoFS(false);

    if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios' && !this.tmaService.hcPremium || this.tmaService.hcWA && this.tmaService.hcSO == 'android' && !this.tmaService.hcPremium){
      this.avoidP = true;
    }
    else{
        this.avoidP = false;
    }

    if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios' || this.tmaService.hcWA && this.tmaService.hcSO == 'android' ){
      this.hideCrown = true;
    }

    this.cidadeAtual = this.route.snapshot.paramMap.get('cidade').replace(/\-/g, ' ');
    if (this.route.snapshot.paramMap.get('cidade') !== '') {
      this.tmaService.shopCidade = this.route.snapshot.paramMap.get('cidade').replace(/\-/g, ' ');
      this.tmaService.shopUF = this.route.snapshot.paramMap.get('uf');
      this.mCidade = this.route.snapshot.paramMap.get('cidade').replace(/\-/g, ' ');
      this.mUF = this.route.snapshot.paramMap.get('uf');
      if (this.tmaService.glDestinoCampanha != '') {
        //redirecionar para a campanha
        var qDestinoCampanha = this.tmaService.glDestinoCampanha;
        this.tmaService.glDestinoCampanha = '';
        if (qDestinoCampanha == 'carrinho') {
          this.router.navigate(['/shopping/carrinho']);
        }
        else {
          this.router.navigate(['/shopping/' + this.mUF + '/' + this.mCidade.replace(/\ /g, '-') + '/' + qDestinoCampanha]);
        }

      }
    }
    // if(this.tmaService.shopCarrinho.length > 0){
    //   this.qtyCart = this.tmaService.shopCarrinho.length;
    // }

    if (localStorage.getItem("tmsCarrinho") !== null) {
      this.tmaService.shopCartFull = JSON.parse(localStorage.getItem('tmsCarrinho'));
      this.tmaService.shopCartFull.forEach(iLoja => {
        iLoja.arrProdutos.forEach(inP => {
          this.qtyCart += inP.qtdProduto;
        });
      });
      this.tmaService.shopQtyF = this.qtyCart;
    }
    else {
      this.tmaService.shopQtyF = 0;
    }


    // if (this.tmaService.shopCartFull.length > 0) {
    //   this.tmaService.shopCartFull.forEach(iLoja => {
    //     iLoja.arrProdutos.forEach(inP => {
    //       this.qtyCart += inP.qtdProduto;
    //     });
    //   });
    //   this.tmaService.shopQtyF = this.qtyCart;
    //   //this.qtyCart = this.tmaService.shopCarrinho.length;

    // }
    // else {
    //   this.tmaService.shopQtyF = 0;
    // }
    //this.loadProdutos();
    this.carregarCats();


  }

  ngOnDestroy() {
    this.slidePause();
  }

  slideAutoPlay() {
    console.log("auto play");
    this.slidePause();
    if (this.arrBanners.length > 1) {
      this.interval = setInterval(() => {
        console.log("interval trigger");
        this.bannerChange('next');
      }, 8000);
    }

  }

  slidePause() {
    console.log("pause");
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  // @ViewChild(MatMenuTrigger) submenu: MatMenuTrigger;

  // @ViewChild('submenu')
  //   set subMenu(value: MatMenu)  {
  //     console.log("test");
  //     //this.arrCategorias[1].elementRef = value;
  //   }

  filtrarSub(categoriaID: any, urlCategoria: any): void {
    console.log(categoriaID);
    this.arrSubF = [];

    this.arrSubF = this.arrSubCat.filter(x => x.idcategoria == categoriaID);
    this.arrSubF.unshift({ subnome: 'Todos', idcategoria: categoriaID, suburl: urlCategoria });
    console.log(this.arrSubF);
    //this.submenu.openMenu();
    //this.submenu.toggleMenu();
  }

  carregarCats(): void {
    //consultas o server
    if (this.tmaService.glCatLoad) {
      //já carregado previamente
      this.arrCategorias = this.tmaService.glArrShopCat;
      this.arrSubCat = this.tmaService.glArrShopSub;
      this.carregarProdutosHome();
    }
    else {
      this.tmaService.listarShopCats()
        .subscribe((qRes) => {
          this.hideCL = true;
          console.log(qRes);
          if (qRes['res'] == 'done') {
            this.arrCategorias = qRes['arrCategorias'];
            this.arrSubCat = qRes['arrSub'];
            this.tmaService.glArrShopCat = qRes['arrCategorias'];
            this.tmaService.glArrShopSub = qRes['arrSub'];
            this.tmaService.glCatLoad = true;
            this.arrCategorias.forEach((qItem, index) => {
              if (this.arrSubCat.find(x => x.idcategoria == qItem.id)) {
                this.arrCategorias[index].existeSub = true;
              }
            });
            console.log(this.arrCategorias);
            this.carregarProdutosHome();
          }
        })
    }

  }

  carregarProdutosHome(): void {
    console.log("carregar produtos home");
    var dadosIn = 'cidade=' + this.mCidade + '&uf=' + this.mUF;

    if (this.tmaService.glDHload) {
      this.listaProdutos = this.tmaService.glArrProdutosHome;
      this.arrBanners = this.tmaService.glArrBanners;
      if (this.arrBanners.length > 0) {

        this.urlBanner = this.tmaService.urlRepositorioS3 + "/ecommerce/banners/";
        this.exibirBanner(0);
      }
      this.urlECfoto = this.tmaService.urlRepositorioS3 + "/ecommerce/products/";
      this.hideCL = true;
      var now = moment();
      console.log(this.tmaService.glTimeLastLoad.diff(now, 'minutes'));
    }
    else {
      this.tmaService.listarShopDH(dadosIn)
        .subscribe((qRes) => {
          console.log(qRes);
          this.hideCL = true;
          if (qRes['res'] == 'done') {
            this.urlECfoto = this.tmaService.urlRepositorioS3 + "/ecommerce/products/";
            this.listaProdutos = qRes['arrProdutosD'];
            this.tmaService.glArrProdutosHome = qRes['arrProdutosD'];
            this.arrBanners = qRes['banners'];
            this.tmaService.glArrBanners = qRes['banners'];
            if (this.arrBanners.length > 0) {
              this.urlBanner = this.tmaService.urlRepositorioS3 + "/ecommerce/banners/";
              this.exibirBanner(0);
            }

            this.tmaService.glDHload = true;
            this.tmaService.glTimeLastLoad = moment();
            console.log(this.tmaService.glTimeLastLoad);

          }
        })
    }
  }


  exibirBanner(qIdx: any): void {
    this.slidePause();

    this.controlsReady = false;
    if (this.arrBanners.length > 1) {
      this.controlsEnabled = true;
    }
    else {
      this.controlsEnabled = false;
    }

    if (this.bannerAtual != '') {
      //not first load probably
      this.novaFoto = false;
      // if(this.arrBanners[qIdx].loaded == undefined){
      //   this.novaFoto = false;
      // }
      setTimeout(() => {
        console.log("exibindo banner " + qIdx);
        this.bannerAtual = this.arrBanners[qIdx].ImagemUrl;
        this.bannerIndex = qIdx;
        this.bannerBG = '#' + this.arrBanners[qIdx].HexColor;
        //seta o banner como carregado
        this.arrBanners[qIdx].loaded = true;

      }, 500);
    }
    else {
      //first time loaded
      // if(this.arrBanners[qIdx].loaded == undefined){
      //   this.novaFoto = false;
      // }
      this.slideAutoPlay();
      console.log("exibindo banner " + qIdx);
      this.bannerAtual = this.arrBanners[qIdx].ImagemUrl;
      this.bannerIndex = qIdx;
      this.bannerBG = '#' + this.arrBanners[qIdx].HexColor;
      this.arrBanners[qIdx].loaded = true;
    }
    if (this.arrBanners[qIdx].TipoDivulgacao == null) {
      this.bannerClick = false;
    }
    else {
      this.bannerClick = true;
    }

    this.contagemLF++;

    // this.bannerBG = this.arrBanners[qIdx].Hexa;
    //fake for now
    // if (qIdx == 0) {
    //   this.bannerBG = '#060709';
    // }
    // else {
    //   this.bannerBG = '#66319b';
    // }

  }

  bannerChange(opcao: any) {
    var qPos = 0;
    if (opcao == 'next') {
      if (this.bannerIndex == this.arrBanners.length - 1) {
        //limite, volta ao inicial
        this.exibirBanner(0);
      }
      else {
        qPos = this.bannerIndex + 1;
        this.exibirBanner(qPos);
      }
    }
    else {
      if (this.bannerIndex == 0) {
        //first, volta para ao ultimo
        qPos = this.arrBanners.length - 1
        this.exibirBanner(qPos);
      }
      else {
        qPos = this.bannerIndex - 1
        this.exibirBanner(qPos);
      }
    }
  }

  clickBanner(): void {
    var infoBanner = this.arrBanners[this.bannerIndex];
    if (infoBanner.TipoDivulgacao == 'produto') {
      this.tmaService.shopUrlAnterior = '/shop/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade.replace(/\ /g, '-');
      this.router.navigate(['/shopping/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade.replace(/\ /g, '-') + '/' + infoBanner.ParametroDivulgacao]);
    }
    if (infoBanner.TipoDivulgacao == 'categoria') {
      this.tmaService.shopUrlAnterior = '/shop/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade.replace(/\ /g, '-');
      this.router.navigate(['/shopping/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade.replace(/\ /g, '-') + '/' + infoBanner.ParametroDivulgacao]);
    }
    if (infoBanner.TipoDivulgacao == 'subcategoria') {
      this.tmaService.shopUrlAnterior = '/shop/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade.replace(/\ /g, '-');
      this.router.navigate(['/shopping/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade.replace(/\ /g, '-') + '/' + infoBanner.ParametroDivulgacao]);
    }

  }

  transitionEnd() {
    //this.novaFoto = true;
  }

  loadingEnd() {
    console.log("image fully loaded");
    this.novaFoto = true;
    this.controlsReady = true;
    this.slideAutoPlay();
  }

  loadProdutos(): void {
    // this.listaProdutos.push({ nome: "100% WHEY GOLD STANDARD", preco: 159.5, precoPremium: 139.9, imagem: 'whey-on-2lb.jpg' })
    // this.listaProdutos.push({ nome: "ISOPURE ZERO CARB", preco: 309.5, precoPremium: 245.9, imagem: 'whey-isopure.jpg' })
    // this.listaProdutos.push({ nome: "ISOPURE ZERO CARB", preco: 309.5, precoPremium: 245.9, imagem: 'whey-isopure.jpg' })
    // this.listaProdutos.push({ nome: "ISOPURE ZERO CARB", preco: 309.5, precoPremium: 245.9, imagem: 'whey-isopure.jpg' })
    // this.listaProdutos.push({ nome: "ISOPURE ZERO CARB", preco: 309.5, precoPremium: 245.9, imagem: 'whey-isopure.jpg' })
    // this.listaProdutos.push({ nome: "100% WHEY GOLD STANDARD", preco: 159.5, precoPremium: 139.9, imagem: 'whey-on-2lb.jpg' })
    // this.listaProdutos.push({ nome: "100% WHEY GOLD STANDARD", preco: 159.5, precoPremium: 139.9, imagem: 'whey-on-2lb.jpg' })
  }
  goDetail(idProduto: any, urlCategoria: any): void {
    this.tmaService.shopUrlAnterior = '/shop/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade.replace(/\ /g, '-');
    this.router.navigate(['/shopping/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade.replace(/\ /g, '-') + '/' + urlCategoria + '/produto/' + idProduto]);
    //this.router.navigate(['/shopping/produto/' + idProduto]);
  }

  goFilter(categoriaProd: any): void {
    this.router.navigate(['/shopping/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade.replace(/\ /g, '-') + '/' + categoriaProd]);
  }
  trocarCidade(): void {
    if (this.tmaService.shopCartFull.length > 0) {
      const avisoIC = this.dialog.open(AlertaConfirmDialog, {
        // width: '250px',
        disableClose: true,
        data: { tituloAlerta: "Aviso", textoAlerta: "Você possui itens no carrinho, ao trocar de local seu carrinho ficará vazio, deseja continuar?", textoCancel: "Não", textoConfirm: "Sim!" }
      });
      avisoIC.afterClosed().subscribe((result) => {
        console.log(result);
        if (result == true) {
          this.tmaService.shopCartFull = [];
          this.tmaService.shopCarrinho = [];
          this.tmaService.glDHload = false;
          localStorage.removeItem("tmsGeoLoja");
          this.router.navigate(['pre-shop/uf']);
        }
      });
    }
    else {
      this.tmaService.glDHload = false;
      localStorage.removeItem("tmsGeoLoja");
      this.router.navigate(['pre-shop/uf']);
    }
  }

  goCart(): void {

    //if(this.tmaService.shopCarrinho.length > 0){
    if (this.tmaService.shopQtyF > 0) {
      this.router.navigate(['shopping/carrinho']);
    }
    else {
      const dialogCartEmpt = this.dialog.open(AlertaSimplesDialog, {
        width: '300px',
        data: { tituloAlerta: "Carrinho Vazio", iconAlerta: 'warning', textoAlerta: "Encontre os produtos desejados e adicione-os ao seu carrinho.", textoConfirm: "Ok" }
      });

    }

  }

  goPedidos(): void {
    this.tmaService.gUrlAnterior = '/shop/' + this.mUF + '/' + this.mCidade.replace(/\ /g, '-');
    this.router.navigate(['/shopping/pedidos']);
  }

  

}
